import { Component, Injector, OnInit } from '@angular/core';
import { StepPaymentValue } from 'models';
import { ProcessStepBaseComponent } from '../../_core/process-step-base.component';

@Component({
  selector: 'sb-step-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent extends ProcessStepBaseComponent implements OnInit {

  public paymentInfoData: StepPaymentValue;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    // super.shouldShowBackButton();
    // super.setFormGroup(this.formsService.generateStepDocumentForm());
    // super.setFormStoreDataFunction(this.appStoreFacadeService.step.storeStepDocumentValue);
    this.getFormDataAndValidation();
  }

  private getFormDataAndValidation() {
    this.subscriptions.add(
      this.appStoreFacadeService.step.paymentValue$
        .subscribe((stepData: StepPaymentValue) => {
          this.paymentInfoData = stepData;
          // super.setFormGroupStepData(stepData);
        })
    );
  }

}
